import { object, string } from "yup"
const validationSchema = object().shape({
    countryOfResidence: string().required("Country of Residence is required"),
    nationality: string().required("Nationality is required"),
})

export default validationSchema